import z from "zod";

const translationPath = "page.4uDlist.listImportAutomation.errors.";

export const listImportAutomationSchema = z
  .object({
    enable: z.boolean(),
    name: z.string().min(1, translationPath + "name"),
    initialDate: z.date({
      invalid_type_error: translationPath + "initial_date",
    }),
    endDate: z.date({ invalid_type_error: translationPath + "end_date" }),
    description: z.string().optional(),
  })
  .superRefine((val, ctx) => {
    if (val.endDate < val.initialDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        message: translationPath + "end_date_less",
      });
    }
  });

export type TListImportAutomation = z.infer<typeof listImportAutomationSchema>;
